
import { i18nText } from '@/locales';
import {LoyaltyCertTypeAddRequestType} from '@/form/loyalty/loyaltyCertType/LoyaltyCertType.types';

export class LoyaltyCertTypeFormData {
    public id?: number | null;
    public name: string | null;
    public writeoff_id: number | null;
    public salon_id?: number | null;
    public balance: number | null;
    public coverage: number | null;
    public period: number | null;
    public services_id: Array<number> | null;
    public products_id: Array<number> | null;

    setFormData(data: LoyaltyCertTypeAddRequestType): void {
        this.id = data.id;
        this.name = data.name;
        this.writeoff_id = data.writeoff_id;
        this.salon_id = data.salon_id;
        this.balance = data.balance;
        this.coverage = data.coverage;
        this.period = data.period;
        this.services_id = data.services_id;
        this.products_id = data.products_id;
    }

    constructor() {
        this.name = '';
        this.writeoff_id = null;
        this.salon_id = null;
        this.balance = null;
        this.coverage = 100;
        this.period = 12;
        this.services_id = [];
        this.products_id = [];
    }
}

export const FormRules = {
    balance: [{required: true, message: i18nText("Данное поле обязательно для заполнения"), trigger: 'change'}],
    name: [{required: true, message: i18nText("Укажите наименование"), trigger: 'change'}],
    writeoff_id: [{required: true, message: i18nText("Укажите тип списания"), trigger: 'change'}],
    // coverage: [
    //     {required: true, message: 'Данное поле обязательно для заполнения', trigger: 'change', type: 'number'},
    //     {min: 10, max: 100, message: 'Нужно указать от 10 до 100.', trigger: 'change', type: 'number'},],
    period: [
        {required: true, min: 0, message: i18nText("Данное поле обязательно для заполнения"), trigger: 'change', type: 'number'},
        {min: 1, max: 36, message: i18nText("Нужно указать от 1 до 36 мес."), trigger: 'change', type: 'number'},
    ],
};
